import * as React from 'react';
import { ControllerProps } from 'src/router';
import { PaymentListController } from '../shared/payments/list/payment-list.controller';

interface Props extends ControllerProps<{}> {
}

export const ClientPaymentList: React.SFC<Props> = (props: Readonly<Props>): JSX.Element => (
	<PaymentListController
		{...props}
		type="client"
	/>
);




// WEBPACK FOOTER //
// ./src/app/accounting/clients/client-payment-list.tsx